import React, { useEffect, useState } from 'react';

import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import Search from '../../elements/Search';
import ViewButton from '../../elements/ViewButton';
import Paginator from '../../elements/paginator';
import { PERMISSION } from '../../helpers/Permissions';
import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';
import { TableCell as Cell } from 'crm/elements/common/TableDetailsRow';
import TableHead from 'crm/elements/common/TableHead';

function PostbacksList() {
    const [postbacks, setPostbacks] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [filter, setFilter] = useState('');
    const postbackUrl = '/crea/api/postback/';

    const getPostbacks = (page) => {
        let requestUrl = postbackUrl;
        requestUrl += `?page=${page}`;
        axios.get(requestUrl, { params: { filter } }).then((response) => {
            setPostbacks(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
    };

    useEffect((page = 1) => {
        getPostbacks(page);
    }, []);

    useEffect(() => {
        getPostbacks();
    }, [filter]);

    function getPostbacksList() {
        return postbacks.map(({ id, url, method, action, slug, hideDelete }) => (
            <tr key={id}>
                <td>
                    <ViewButton url={`/postbacks/${id}`} permissions={[PERMISSION.VIEW_POSTBACK]} />
                    <EditButton url={`/postbacks/${id}/edit`} permissions={[PERMISSION.UPDATE_POSTBACK]} />
                    {!hideDelete && (
                        <DeleteButton
                            url={postbackUrl + id}
                            action={() => getPostbacks(currentPage)}
                            permissions={[PERMISSION.DELETE_POSTBACK]}
                        />
                    )}
                </td>
                <Cell>{id}</Cell>
                <Cell>{url}</Cell>
                <Cell>{slug}</Cell>
                <Cell>{method}</Cell>
                <Cell>{action}</Cell>
            </tr>
        ));
    }

    return (
        <>
            <ActionButton url="/postbacks/create" title="Create new postback" permissions={[PERMISSION.CREATE_POSTBACK]} />
            <Card title="All postbacks">
                <Search filterTable={(value) => setFilter(value)} />
                <div className="table-responsive">
                    <table className="table model-list">
                        <TableHead>
                            <div />
                            <th>ID</th>
                            <th>Url</th>
                            <th>Slug</th>
                            <th>Method</th>
                            <th>Action</th>
                        </TableHead>
                        <tbody>{getPostbacksList()}</tbody>
                    </table>
                    <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getPostbacks} />
                </div>
            </Card>
        </>
    );
}

export default PostbacksList;
